import type { ArticleDraftStatus } from '@modules/firebase-core';

export interface ArticleStatusChipProps {
  label: 'Published' | 'Draft' | 'Retired';
  color: 'success' | 'default';
  variant: 'filled' | 'outlined';
}

/** One source for the article status chip (list + editor). Retired (G3): neutral, filled — not live, not editable-draft. */
export function articleStatusChipProps(status: ArticleDraftStatus): ArticleStatusChipProps {
  if (status === 'published') return { label: 'Published', color: 'success', variant: 'filled' };
  if (status === 'retired') return { label: 'Retired', color: 'default', variant: 'filled' };
  return { label: 'Draft', color: 'default', variant: 'outlined' };
}
